import { render, staticRenderFns } from "./NsbBaru.vue?vue&type=template&id=362224f0&scoped=true&"
import script from "./NsbBaru.vue?vue&type=script&lang=js&"
export * from "./NsbBaru.vue?vue&type=script&lang=js&"
import style0 from "./NsbBaru.vue?vue&type=style&index=0&id=362224f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362224f0",
  null
  
)

export default component.exports